import * as React from 'react';
import {viewNode} from '../shared-exports';
import {RouteContext} from './route';

export interface ScrollCacheContext { 
	[path: string]: number
}

type ScrollDispathTuple = [
	ScrollCacheContext,
	(cache: ScrollCacheContext) => void
];

export const ScrollCacheContext = React.createContext({} as ScrollCacheContext);

export function ScrollCache(props: any) {
	const route = React.useContext(RouteContext);
	const [cache, _]: ScrollDispathTuple = React.useState({})

	const beforeNavigate = (path: string) => {
		const element = document.getElementById(viewNode);
		if (element != null) {
			const value = element.scrollTop;
			cache[path] = value;
		}
	}

	React.useEffect(() => {
		route.addBeforeNavigateListener(beforeNavigate)
		return () => {
			route.removeBeforeNavigateListener(beforeNavigate)
		}
	}, [])

	return (
		<ScrollCacheContext.Provider value={cache}>
			{props.children}
		</ScrollCacheContext.Provider>
	);
}
